export interface SoilAnalysisState {
  defaultSoilAnalyses?: SoilAnalysis[];
}

export interface SoilAnalysis {
  id: number;
  description: string;
  state: State;
  characteristics: CharacteristicData;
}

export interface CharacteristicData {
  carbonToNitrogenRatio?: number;
  deliverableNitrogen?: number;
  totalNitrogen?: number;
  minNitrogen?: number;
  phosphorusAmmoniumLactate?: number;
  phosphorusNumber?: number;
  plantAvailablePhosphorus?: number;
  potassiumNumber?: number;
  plantAvailableMagnesium?: number;
  calciumCarbonate?: number;
  organicMatter?: number;
  soilAcidityNir?: number;
  soilAcidity?: number;
  ammoniaStock?: number;
  nitrateStock?: number;
  plantAvailablePotassium?: number;
  plantAvailableCalcium?: number;
  calciumStock?: number;
  copperStock?: number;
  ferroStock?: number;
  cationExchangeCapacity?: number;
  calciumFilling?: number;
  magnesiumFilling?: number;
  potassiumFilling?: number;
  sodiumFilling?: number;
  soilAvailablePotassium?: number;
  potassiumStock?: number;
  cecClayHumus?: number;
}

export enum State {
  Draft = 'Draft',
  Active = 'Active',
  InActive = 'InActive',
}
